<template lang="pug">
  div
    button.btn.btn-sm.btn-success(@click="showClickLinkLogs") クリック一覧
    ClickLinkLogsModal(
      v-if="$store.state[this.state_name].show_click_link_logs_modal"
      :state_name="state_name"
    )
    UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
</template>

<script>
import ClickLinkLogsModal from './modals/click_link_logs_modal.vue';
import UpgradeUpperMaster from './modals/upgrade_upper_master.vue';

export default {
  props: {
    state_name: {
      type: String,
      default: 'heatmap'
    },
    heatmap_id: {
      type: Number,
      required: true,
    },
    is_upper_master: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      is_upgrade_upper_master_modal: false,
    }
  },
  methods: {
    async showClickLinkLogs() {
      if (!this.is_upper_master) {
        this.is_upgrade_upper_master_modal = true;
        return;
      }

      try {
        // 既存のデータとローディング状態をクリア
        this.$store.commit(`${this.state_name}/setClickLinkLogs`, []);
        this.$store.commit(`${this.state_name}/setClickLinkLogsLoading`, false);
        // モーダルを先に開く
        this.$store.commit(`${this.state_name}/setShowClickLinkLogsModal`, true);
        // APIを実行
        await this.$store.dispatch(`${this.state_name}/getClickLinkLogs`, {
          heatmap_id: this.heatmap_id
        });
      } catch (error) {
        console.error('Error fetching click link logs', error);
        alert('クリック一覧の取得に失敗しました。');
        // エラーの場合はモーダルを閉じる
        this.$store.commit(`${this.state_name}/setShowClickLinkLogsModal`, false);
        this.$store.commit(`${this.state_name}/setClickLinkLogsLoading`, false);
      }
    },
  },
  components: {
    ClickLinkLogsModal,
    UpgradeUpperMaster,
  },
};
</script>
